import type { SVGProps } from 'react';
export const Pin = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M7.86 12.34c.25.25.25.67 0 .92l-3.08 3.09a.66.66 0 0 1-.93-.93l3.08-3.08a.66.66 0 0 1 .93 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.99 3.34a1.17 1.17 0 0 1 1.65 0l4.02 4.03a1.17 1.17 0 0 1 0 1.64m0 0-3.5 3.51c.6 1.72-.39 3.32-.91 4.02a1.17 1.17 0 0 1-1.75.12L3.33 9.51a1.17 1.17 0 0 1 .1-1.74 4.5 4.5 0 0 1 4.04-.9l3.5-3.53m.83.98L8.1 8.05c-.2.2-.49.24-.73.12l-.04-.02-.18-.06q-.25-.09-.7-.11a3.2 3.2 0 0 0-2.11.71l6.98 6.98c-.03.04.02-.03 0 0 .52-.73 1.08-1.9.53-3.01a.6.6 0 0 1 .12-.73l3.72-3.74z"
      clipRule="evenodd"
    />
  </svg>
);
